import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {UserService} from "../services/user.service";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private user: UserService)
    {

    }

    async canActivate() {

        if (!this.user.isAuthenticated) {
            this.user.goToLogin();
        }

        return true;
    }
}
